import * as Avatar from 'primitives/avatar'
import { useAuthContext } from '@repo/cf-user/contexts/auth'

// oxlint-disable-next-line complexity
export function UserAvatar() {
  const authData = useAuthContext()
  const userData = authData?.userData
  const name = `${userData?.firstName ?? ''} ${userData?.lastName ?? ''} avatar image`
  const initials = `${userData?.firstName?.[0] ?? ''}${userData?.lastName?.[0] ?? ''}`

  const isUserUploadedImage = userData?.avatarUrl?.includes(
    'creativefabrica.com/wp-content/uploads/users',
  )

  // Build sized URL for CF-hosted images by adding size suffix before extension
  const regex = /(\.[^.]+)$/
  const buildSizedUrl = (baseUrl: string, size: string) => {
    const ext = baseUrl.match(regex)?.[0] ?? ''
    const base = baseUrl.replace(regex, '')
    return `${base}-${size}${ext}`
  }

  const buildSrcSet = (baseUrl: string) =>
    ['64x64', '80x80', '150x150', '300x300']
      .map(size => `${buildSizedUrl(baseUrl, size)} ${size.split('x')[0]}w`)
      .join(', ')

  return (
    <Avatar.Root
      size="small"
      rounded="full"
      className="inline-flex h-5 w-5 min-w-5 shrink-0 select-none"
    >
      {isUserUploadedImage ? (
        <Avatar.Image
          src={buildSizedUrl(userData?.avatarUrl ?? '', '64x64')}
          srcSet={buildSrcSet(userData?.avatarUrl ?? '')}
          sizes="20px"
          alt={name}
        />
      ) : (
        <Avatar.Image src={userData?.avatarUrl ?? ''} alt={name} />
      )}
      <Avatar.Fallback className="leading-1 bg-cf-dreamy-cloud-400 text-cf-dreamy-cloud-900 text-xxs flex h-5 w-5 items-center justify-center rounded-full font-bold uppercase">
        {initials}
      </Avatar.Fallback>
    </Avatar.Root>
  )
}
